import { Link } from '@reach/router';
import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import AccountMemberList from '../../../components/settings/account/AccountMemberList';
import AccountMemberProfile from '../../../components/settings/account/AccountMemberProfile';
import AccountName from '../../../components/settings/account/AccountName';
import { ButtonFilled } from '../../../components/ui';
import { ErrorScreen } from '../../../components/utils';
import { AccountContext } from '../../../context/account';
import { UserContext } from '../../../context/UserContext';
import { accountQuery } from '../../../queries/account';
import { AccountQuery, AccountQueryVariables } from '../../../queries/__generated__/AccountQuery';

const NotebookSettings = () => {
  const accountContext = useContext(AccountContext);
  const { user } = useContext(UserContext);

  return (
    <Query<AccountQuery, AccountQueryVariables>
      query={accountQuery}
      variables={{ id: accountContext.selectedAccountId }}
    >
      {({ data, loading, error }) => {
        if (loading) {
          return <div />;
        }
        if (error) {
          return <ErrorScreen error={error.message} />;
        }

        const account = data!.account!;

        const isUserAccountOwner = user.id === account.owner.id;

        return (
          <div
            className="w-100 mw8 center pb5 pt4 pt5-ns"
            style={{
              maxWidth: 695
            }}
          >
            <h1 className="f3 display fw8 mt0 mb3">Space Settings</h1>
            <AccountName account={account} />
            <AccountMemberProfile account={account} />
            <AccountMemberList account={account} />
            {isUserAccountOwner && (
              <ButtonFilled as={Link} to="/notebook/delete" data-testid="delete-notebook-button">
                Delete Space
              </ButtonFilled>
            )}
          </div>
        );
      }}
    </Query>
  );
};

export default NotebookSettings;
